import { type Commodity } from './Commodity'
import { type WeightType } from './PackageType'
import { type ShippingItem } from './ShippingItem'

export function getStopShippingItems(
  shippingItems: Array<ShippingItem>,
  stopType: string,
  stopIndex: number
) {
  return shippingItems.filter(shippingItem => {
    if (stopType === 'pickup') {
      return shippingItem.pickupStopIndex === stopIndex
    }
    return shippingItem.deliveryStopIndex === stopIndex
  })
}

export function getTotalHandlingUnits(shippingItems: ShippingItem[] = []): number {
  return shippingItems.reduce((total, current) => {
    if (current.packageCount == null) {
      return total
    }
    return Number(current.packageCount) + total
  }, 0)
}

function calculatePartialWeight(
  commodities: Array<Commodity>,
  item: ShippingItem,
  weightType?: WeightType
) {
  return (
    commodities &&
    commodities.reduce((commoditiesTotalWeight, commodity) => {
      const parsedWeight = Number.parseFloat(String(commodity.weight)) || 0

      if (weightType === 'per_package') {
        const parsedPackageCount = Number.parseInt(String(item.packageCount), 10) || 0

        return commoditiesTotalWeight + parsedWeight * parsedPackageCount
      }

      return commoditiesTotalWeight + parsedWeight
    }, 0)
  )
}

export function getTotalShippingItemsWeight(items: ShippingItem[]): number {
  return items.reduce((totalWeight, item) => {
    const { weightType, commodities } = item

    if (!commodities) {
      return totalWeight
    }

    const partialWeight = calculatePartialWeight(commodities, item, weightType)

    return totalWeight + partialWeight
  }, 0)
}

export function getCommodityDescription(commodities: Array<Commodity>) {
  return commodities.find(commodity => commodity.description)?.description
}

export function getComposeCommodityDescription(
  commodities: Array<Commodity>,
  baseCommodityDescription?: string
) {
  if (!baseCommodityDescription) {
    return ''
  }
  const addedCommoditiesDescription = commodities.length > 1 ? `+${commodities.length - 1}` : ''
  return `${baseCommodityDescription}${addedCommoditiesDescription}`
}
